<template>
  <el-dialog
    title="线下扫码送积分"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    width="800px"
    @closed="handleClosed">
    <el-table
      v-loading="loading"
      border
      :data="list"
      height="300">
      <el-table-column
        prop="ruleName"
        label="活动名称">
      </el-table-column>
      <el-table-column
        prop="points"
        width="100"
        label="积分">
      </el-table-column>
      <el-table-column
        prop="gainPointsCount"
        width="100"
        label="参与人数">
      </el-table-column>
      <el-table-column
        label="活动状态"
        width="80">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.isopen"
            :active-value="1"
            :inactive-value="0"
            @change="(e) => { onSwitchChange(e,scope.row) }">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="180">
        <template slot-scope="{row}">
          <el-button
            type="text"
            @click="edit(row)">编辑</el-button>
          <el-button
            type="text"
            @click="deleteofflineactivityrule(row)">删除</el-button>
          <a
            style="margin-left: 10px;color: #409EFF; text-decoration: none;"
            :href="qrcode + '?data='+row.jumpWxappGainPointsUrl"
            target="_blank">下载二维码</a>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 10px;text-align: center;"
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <template slot="footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="edit()">新 增</el-button>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关 闭</el-button>
    </template>
    <el-dialog
      title="活动管理"
      :visible.sync="editVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body=""
      width="550px"
      @closed="handleEditClosed">
      <el-form
        ref="ruleForm"
        :model="editForm"
        :rules="rules"
        label-width="100px">
        <el-form-item
          label="活动名称："
          prop="ruleName">
          <el-input v-model="editForm.ruleName"></el-input>
        </el-form-item>
        <el-form-item
          label="积分："
          prop="points">
          <el-input-number
            v-model="editForm.points"
            :min="1"></el-input-number>
        </el-form-item>
        <el-form-item
          label="是否开启："
          prop="isopen">
          <el-switch
            v-model="editForm.isopen"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
        <!-- <el-form-item label="活动时间："
          prop="time">
          <el-date-picker v-model="editForm.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间">
          </el-date-picker>
        </el-form-item> -->
      </el-form>
      <template slot="footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="editSubmit">确 定</el-button>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Common from '../../service/common'
export default {
  name: 'OfflineScanModal',
  data() {
    return {
      editVisible: false,
      qrcode: Common.getqrcodepic,
      editForm: {

      },
      rules: {
        ruleName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        points: [
          { required: true, message: '请输入积分', trigger: 'blur' }
        ]
      },
      visible: false,
      loading: false,
      list: [],
      totalNum: 0,
      config: {
        vendorId: null,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.totalNum = 0
      this.config = {
        pageNum: 1,
        pageSize: 10
      }
    },
    handleEditClosed() {
      this.editForm = {}
    },
    edit(row = {}) {
      this.editForm = {
        ...this.editForm,
        points: 1,
        isopen: 1,
        ...row
      }
      this.editVisible = true
    },
    editSubmit() {
      if (this.editForm.ruleId) {
        this.updateofflineactivityrule()
      } else {
        this.addofflineactivityrule()
      }
    },
    addofflineactivityrule() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('integral/addofflineactivityrule', {
            payload: {
              ruleName: this.editForm.ruleName,
              points: this.editForm.points,
              isopen: this.editForm.isopen,
              vendorId: this.config.vendorId
            },
            success: () => {
              this.loading = false
              this.editVisible = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    updateofflineactivityrule() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('integral/updateofflineactivityrule', {
            payload: {
              ruleId: this.editForm.ruleId,
              ruleName: this.editForm.ruleName,
              points: this.editForm.points,
              isopen: this.editForm.isopen,
              vendorId: this.config.vendorId
            },
            success: () => {
              this.loading = false
              this.editVisible = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    deleteofflineactivityrule(row) {
      this.$confirm('您确定删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('integral/deleteofflineactivityrule', {
            payload: {
              ruleId: row.ruleId,
              vendorId: this.config.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    onSwitchChange(e, row) {
      console.log(e)
      if (e === 0) {
        this.closeofflineactivityrule(row)
      } else {
        this.openofflineactivityrule(row)
      }
    },
    closeofflineactivityrule(row) {
      this.$confirm('您确定关闭该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('integral/closeofflineactivityrule', {
            payload: {
              ruleId: row.ruleId,
              vendorId: this.config.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    openofflineactivityrule(row) {
      this.$confirm('您确定开启该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('integral/openofflineactivityrule', {
            payload: {
              ruleId: row.ruleId,
              vendorId: this.config.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('integral/getofflineactivityrules', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records.map(i => ({
            ...i,
            jumpWxappGainPointsUrl: encodeURIComponent(i.jumpWxappGainPointsUrl)
          }))
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(vendorId) {
      this.config.vendorId = vendorId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
